// Module
var code = " {{'STUDENT_APPLICATIONS.code' | translate}}: <span class=\"code\">{{code}}</span> ";
// Exports
module.exports = code;